<template>
  <div class="max-w-3xl mx-auto space-y-6">
    <Paragraph>
      {{ t("terms.intro") }}
      <Link href="/legal/algemene-voorwaarden.pdf">
        {{ t("terms.full_version_link") }} </Link
      >.
    </Paragraph>

    <Section :title="t('terms.agreement_title')">
      <Paragraph>{{ t("terms.agreement_text") }}</Paragraph>
    </Section>

    <Section :title="t('terms.external_conditions_title')">
      <Paragraph>{{ t("terms.external_conditions_text") }}</Paragraph>
    </Section>

    <Section :title="t('terms.account_info_title')">
      <Paragraph>{{ t("terms.account_info_text") }}</Paragraph>
    </Section>

    <Section :title="t('terms.maintenance_backups_title')">
      <Paragraph>{{ t("terms.maintenance_backups_text") }}</Paragraph>
    </Section>

    <Section :title="t('terms.upgrades_domains_title')">
      <Paragraph>{{ t("terms.upgrades_domains_text") }}</Paragraph>
    </Section>

    <Section :title="t('terms.payments_price_title')">
      <Paragraph>{{ t("terms.payments_price_text") }}</Paragraph>
    </Section>

    <Section :title="t('terms.use_of_services_title')">
      <Paragraph>{{ t("terms.use_of_services_text") }}</Paragraph>
    </Section>

    <Section :title="t('terms.rights_data_title')">
      <Paragraph>{{ t("terms.rights_data_text") }}</Paragraph>
    </Section>

    <Section :title="t('terms.termination_title')">
      <Paragraph>{{ t("terms.termination_text") }}</Paragraph>
    </Section>
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import Section from "@/components/ui/Section.vue";
import Paragraph from "@/components/ui/Paragraph.vue";
import Link from "@/components/ui/Link.vue";

const { t } = useI18n();
</script>
